import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react';

import { useAppMode } from 'component/root/AppModeProvider';

interface ConditionalAuth0ProviderProps extends Auth0ProviderOptions {
  readonly children: React.ReactNode;
}

const ConditionalAuth0Provider = ({ children, ...auth0Props }: ConditionalAuth0ProviderProps) => {
  const { usesAuth0 } = useAppMode();

  if (!usesAuth0) {
    return <>{children}</>;
  }

  return <Auth0Provider {...auth0Props}>{children}</Auth0Provider>;
};

export default ConditionalAuth0Provider;
